export default __webpack_public_path__ + "static/venn-diagram-tablet-e76e0baaf1afcab3e5a8063f6bd0dbce.svg";